import * as z from "zod/v4";
import { onboardingV2StatusSchema } from "./get-onboardings-v2";

export const onboardingV2DetailSchema = z.object({
  id: z.string(),
  teamId: z.string(),
  productId: z.string(),
  version: z.number(),
  status: onboardingV2StatusSchema,
  currentStepId: z.string(),
  dealSize: z.number().nullable(),
  startedAt: z.string(),
  updatedAt: z.string(),
  completedAt: z.string().nullable(),
  archivedAt: z.string().nullable(),
  archivedByUserId: z.string().nullable(),
  startedByUserId: z.string().nullable(),
  lastUpdatedByUserId: z.string().nullable(),
  stepsCompleted: z.number(),
  totalSteps: z.number(),
  totalTimeMs: z.number(),
  teamName: z.string(),
  teamDomain: z.string().nullable(),
  hubspotDealId: z.string().nullable(),
  formData: z.record(z.string(), z.unknown()),
  stepTimestamps: z.record(z.string(), z.unknown()),
  hubspotSync: z.unknown().nullable(),
});

export type OnboardingV2Detail = z.infer<typeof onboardingV2DetailSchema>;

export const getOnboardingV2Detail = {
  name: "getOnboardingV2Detail" as const,
  input: z.object({ teamId: z.string().min(1), productId: z.string().min(1) }),
  output: z.object({ detail: onboardingV2DetailSchema.nullable() }),
};

export type GetOnboardingV2DetailInput = z.infer<
  typeof getOnboardingV2Detail.input
>;
export type GetOnboardingV2DetailOutput = z.infer<
  typeof getOnboardingV2Detail.output
>;
